
import { mapGetters } from 'vuex'

import BuyingGuideCard from '@buying-guide/components/Card'

export default {
  components: {
    BuyingGuideCard,
  },

  computed: {
    ...mapGetters({
      buyingGuide: 'landing/buyingGuide',
    }),
  },
}
